/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempNetworkLibrary: {
  name: 'temp-network-library';
  data: string;
} = {
  name: 'temp-network-library',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 2a2 2 0 0 0-2 2v1H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8Zm9 16v1H5V7h1v9a2 2 0 0 0 2 2h9ZM8 6v10h12V4H8v2Z" fill="currentColor"/></svg>`,
};
